"use strict";

exports.__esModule = true;
exports.getWidget = getWidget;
exports.getWidgetOrThrow = getWidgetOrThrow;
/**
 * Get a widget with the given name.
 */
function getWidget(widgets, name) {
  for (var i = 0; i < widgets.length; i++) {
    var widget = widgets[i];
    if (widget.name === name) {
      return widget;
    }
  }
}

/**
 * Get a widget with the given name.
 *
 * @throws {Error} if no widget is found.
 */
function getWidgetOrThrow(widgets, name) {
  var widget = getWidget(widgets, name);
  if (widget === undefined) {
    throw new Error("No such widget: " + name);
  }
  return widget;
}